export class DragImageCreator {
    private blacklistSelectors: string[] = ["button",".mud-tooltip-root",".mud-ripple","input","textarea","select"];
    
    private createEmptyContainer(width: number = 0, height: number = 0): HTMLElement {
        const container = document.createElement('div');
        container.style.width = `${width}px`;
        container.style.height = `${height}px`;
        return this.setDragImageContainerStyle(container);
    }
    private setDragImageContainerStyle(container: HTMLElement): HTMLElement {
        container.setAttribute('style', `
            all: initial !important;
            position: absolute !important;
            top: 0px !important;
            left: 0px !important;
            z-index: 9999 !important;
            pointer-events: none !important;
            display: block !important;
            visibility: visible !important;
            opacity: 1 !important;
            transform: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
            background: transparent !important;
            box-shadow: none !important;
            outline: none !important;
            overflow: visible !important;
        `);
        
        return container;
    }
    private createFallbackFromElement(element: HTMLElement): HTMLElement {
        const fallback = element.cloneNode(true) as HTMLElement;
        fallback.style.cssText = `
            position: absolute !important;
            top: -9999px !important;
            left: -9999px !important;
            z-index: 9999 !important;`;
        return fallback;
    }
    private removeBlacklistedNodes(element: HTMLElement): HTMLElement {
        this.blacklistSelectors.forEach(sel => {
            element.querySelectorAll(sel).forEach(node => node.remove());
        });
        return element;
    }
    
    private copyAllStyles(fromElement: HTMLElement, toElement: HTMLElement): HTMLElement {
        const styles = window.getComputedStyle(fromElement);

        for (const property of styles) {
            try {
                const value = styles.getPropertyValue(property);
                if (value && value !== 'initial' && value !== 'inherit') {
                    toElement.style.setProperty(property, value, 'important');
                }
            } catch (e) {
                console.debug(`Could not copy style ${property}:`, e);
            }
        }
        
        return toElement;
    }
    
    private copyAllChildrenStyles(originalParent: HTMLElement, cloneParent: HTMLElement): HTMLElement {
        const origChildren:HTMLElement[] = Array.from(originalParent.children) as HTMLElement[];
        const cloneChildren:HTMLElement[] = Array.from(cloneParent.children) as HTMLElement[];

        for (let i = 0; i < origChildren.length; i++) {
            if (cloneChildren[i]) {
                cloneChildren[0].style.pointerEvents = 'none';
                this.copyAllStyles(origChildren[i], cloneChildren[i]);
                this.copyAllChildrenStyles(origChildren[i], cloneChildren[i]);
            }
        }
        
        return cloneParent;
    }
    private clearElementPositioningStyles(element: HTMLElement): HTMLElement {
        element.style.setProperty('position', 'static', 'important');
        element.style.setProperty('float', 'none', 'important');
        element.style.setProperty('clear', 'none', 'important');
        return element;
    }
    public createFromElement(element: HTMLElement) {
        try {
            const container = this.createEmptyContainer(element.offsetWidth, element.offsetHeight);
            const clone = element.cloneNode(true) as HTMLElement;
            
            this.removeBlacklistedNodes(clone);
            this.copyAllStyles(element, clone);
            this.clearElementPositioningStyles(clone);
            this.copyAllChildrenStyles(element, clone);

            container.appendChild(clone);
            
            return container;

        } catch (error) {
            return this.createFallbackFromElement(element);
        }
    }
}